var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col py-8 px-16"},[(_vm.$slots['label'])?_c('div',{staticClass:"text-gray-500 text-sm"},[_vm._t("label")],2):_vm._e(),_c('div',{staticClass:"text-black-500"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }